export default "__VITE_ASSET__DFesey9C__"